const richtextApi = {
  el: {
    sections: document.querySelectorAll('.richtext'),
  },

  init() {
    if (this.el.sections) {
      this.el.sections.forEach((section) => {
        const text = section.innerHTML
        const matches = text.match(/\[(.*?)]/g)
        const words = [] as Array<string>
        if (matches !== null) {
          matches.map((val) => {
            let word = val.replace('[', '')
            word = word.replace(']', '')
            words.push(word)
          })
        }
        if (words.length > 0) {
          this.getApiValues(words, section)
        }
      })
    }
  },

  getApiValues: async (words, section) => {
    const action = '/umbraco/api/data/GetKeyNumbersData'
    const method = 'GET'

    try {
      const req = await fetch(action, {
        method: method,
      })
      const res = await req.json()
      richtextApi.renderApiValues(words, section, res)
    } catch (error) {
      console.error('Error getting richtext api values', error)
    }
  },

  renderApiValues: (words, section, response) => {
    const res = response.data.returnItem
    let text = section.innerHTML

    if (res) {
      words.forEach((word) => {
        const selectedWord = `[${word}]`
        let wordFound = false
        res.forEach((keyNumber) => {
          if (keyNumber.key === word) {
            text = text.replace(selectedWord, keyNumber.value)
            wordFound = true
          }
        })
        if (!wordFound) {
          text = text.replace(selectedWord, word)
        }
      })
    }

    section.innerHTML = text
  },
}

export default richtextApi
